
export const GET_FOOTERNAV_REQUEST = "GET_FOOTERNAV_REQUEST";
export const GET_FOOTERNAV_SUCCESS = "GET_FOOTERNAV_SUCCESS";
export const GET_FOOTERNAV_FAILURE = "GET_FOOTERNAV_FAILURE";